// components/EventModal.jsx
import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const EventModal = ({ event, isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
          onClick={onClose}
        >
          <motion.div 
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            transition={{ type: 'spring', damping: 20 }}
            className="relative bg-white rounded-lg shadow-xl max-w-2xl w-full mx-4"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="absolute top-4 right-4">
              <button 
                onClick={onClose} 
                className="text-gray-400 hover:text-gray-600 transition-colors duration-200"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
              </button>
            </div>

            <div className="p-6 pt-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Event Overview</h2>
              
              <div className="bg-gray-50 rounded-lg p-4 mb-6">
                <div className="flex flex-col md:flex-row gap-6">
                  <div className="flex-shrink-0">
                    <motion.img 
                      src={event?.image || "https://via.placeholder.com/150"}
                      alt={event?.name || "Event poster"} 
                      className="w-full md:w-40 h-auto object-cover rounded"
                      whileHover={{ scale: 1.05 }}
                    />
                  </div>
                  
                  <div className="flex-grow">
                    <h3 className="text-xl font-bold text-gray-800 mb-2">
                      {event?.name || "Nigeria Female Entrepreneurs Conference"}
                    </h3>
                    
                    <div className="space-y-2">
                      <p className="text-sm">
                        <span className="font-medium text-gray-700">Category:</span>{" "}
                        <span className="text-gray-900">{event?.category || "Music"}</span>
                      </p>
                      
                      <p className="text-sm">
                        <span className="font-medium text-gray-700">Organizer:</span>{" "}
                        <span className="text-gray-900">{event?.organizer || "Favour Favour"}</span>
                      </p>
                      
                      <p className="text-sm">
                        <span className="font-medium text-gray-700">Organizer Contact:</span>{" "}
                        <span className="text-gray-900">{event?.contact || "favour@favour.com"}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Ticket Info</h2>
              
              <div className="bg-gray-50 rounded-lg p-4">
                <div className="space-y-3">
                  <p className="text-sm">
                    <span className="font-medium text-gray-700">Ticket tiers:</span>{" "}
                    <span className="text-gray-900">{event?.ticketTiers || "(Vip, Regular,)"}</span>
                  </p>
                  
                  <p className="text-sm">
                    <span className="font-medium text-gray-700">Pricing:</span>{" "}
                    <span className="text-gray-900">₦{event?.price || "5,000"}</span>
                  </p>
                  
                  <p className="text-sm">
                    <span className="font-medium text-gray-700">Availability:</span>{" "}
                    <span className="text-green-600 font-medium">{event?.availability || "Available"}</span>
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default EventModal;